<template>
  <b-modal
    id="modal-co-request-detail"
    ref="modal-co-request-detail"
    title="CO Balance Request Details"
    ok-only
    ok-title="Close"
    size="md"
    @hidden="$emit('hidden')"
  >
    <div v-if="selectedCompOffRequest">
      <b-card class="mb-0 shadow-none border">
        <div class="d-flex justify-content-between align-items-start mb-3">
          <h6 class="mb-0 font-weight-bold text-primary">
            <feather-icon icon="RefreshCwIcon" size="16" class="mr-1" />
            Compensatory Off Balance Request
          </h6>
          <b-badge :variant="getStatusVariant(selectedCompOffRequest.status)" pill>
            {{ selectedCompOffRequest.status || 'Pending' }}
          </b-badge>
        </div>

        <b-row>
          <b-col sm="6" class="mb-2">
            <div class="text-muted small font-weight-bold mb-1">Employee ID</div>
            <div>{{ selectedCompOffRequest.emp_id || '-' }}</div>
          </b-col>
          <b-col sm="6" class="mb-2">
            <div class="text-muted small font-weight-bold mb-1">Employee Name</div>
            <div>{{ getUserName(selectedCompOffRequest.emp_id) || selectedCompOffRequest.emp_id || '-' }}</div>
          </b-col>
          <b-col sm="6" class="mb-2">
            <div class="text-muted small font-weight-bold mb-1">Department</div>
            <div>{{ getApplicantDepartment(selectedCompOffRequest) || currentUserDepartment || '-' }}</div>
          </b-col>
          <b-col sm="6" class="mb-2">
            <div class="text-muted small font-weight-bold mb-1">Request Date</div>
            <div>{{ formatDate(selectedCompOffRequest.created_at || selectedCompOffRequest.createdAt) || '-' }}</div>
          </b-col>
          <b-col sm="6" class="mb-2">
            <div class="text-muted small font-weight-bold mb-1">CO Days Worked (Earned On)</div>
            <div>{{ formatDate(selectedCompOffRequest.from_date || selectedCompOffRequest.work_date) || '-' }}</div>
          </b-col>
          <b-col sm="6" class="mb-2">
            <div class="text-muted small font-weight-bold mb-1">CO Days Requested</div>
            <div>{{ selectedCompOffRequest.total_days != null ? selectedCompOffRequest.total_days + (selectedCompOffRequest.total_days === 1 ? ' day' : ' days') : '-' }}</div>
          </b-col>
          <b-col sm="6" class="mb-2">
            <div class="text-muted small font-weight-bold mb-1">CO Balance Available</div>
            <div class="font-weight-bold text-success">{{ coBalance != null ? coBalance + ' day' + (coBalance === 1 ? '' : 's') : '-' }}</div>
          </b-col>
        </b-row>

        <div v-if="selectedCompOffRequest.comment" class="mt-2 pt-2 border-top">
          <div class="text-muted small font-weight-bold mb-1">Reason</div>
          <div class="text-muted">{{ parseCoRequestReason(selectedCompOffRequest.comment) }}</div>
        </div>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BCard, BRow, BCol, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'CORequestDetailModal',
  components: {
    BModal, BCard, BRow, BCol, BBadge,
  },
  props: {
    selectedCompOffRequest: { type: Object, default: null },
    coBalance: { type: Number, default: null },
    currentUserDepartment: { type: String, default: '' },
    formatDate: { type: Function, default: (d) => d },
    getStatusVariant: { type: Function, default: () => 'secondary' },
    getUserName: { type: Function, default: () => '' },
    getApplicantDepartment: { type: Function, default: () => '' },
    parseCoRequestReason: { type: Function, default: (c) => c },
  },
}
</script>
